import React from 'react';
import './Header.css'; // Import the CSS file

const Header = () => {
    return (
        <header className="header">
            {/* <button className="sidebar-trigger">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-panel-left">
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M9 3v18"></path>
                </svg>
                <span className="sr-only">Toggle Sidebar</span>
            </button>
            <div className="divider"></div>
            <div className="mobile-menu">
                <button className="menu-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tabler-icon tabler-icon-menu">
                        <path d="M4 8l16 0"></path>
                        <path d="M4 16l16 0"></path>
                    </svg>
                </button>
            </div> */}
            <nav className="nav-links">
                <a href="" className="nav-link">Overview</a>
                <a className="nav-link disabled">Customers</a>
                <a className="nav-link disabled">Products</a>
                <a className="nav-link disabled">Settings</a>
            </nav>
            <div className="header-actions">
                <button className="search-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tabler-icon tabler-icon-search">
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                        <path d="M21 21l-6 -6"></path>
                    </svg>
                    <span className="search-text">Search</span>
                </button>
                <button className="profile-button">
                    <span className="profile-initials">MK</span>
                </button>
            </div>
        </header>
    );
};

export default Header;